import { render, staticRenderFns } from "./UploadItem.vue?vue&type=template&id=2b78dc3f&"
import script from "./UploadItem.vue?vue&type=script&lang=js&"
export * from "./UploadItem.vue?vue&type=script&lang=js&"
import style0 from "./UploadItem.vue?vue&type=style&index=0&id=2b78dc3f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
